import axios from "axios";
import authToken from '../context/token'
import useLogout from "../services/auth/useLogout";

async function http(config) {
  const result = await axios(config);
  return result.data;
}

async function request(url, data, method = 'POST', verify = false, tries = 3) {
  const { token, setAccessToken } = authToken;

  if (token.refreshToken === null) {
    throw {
      message: "Unauthorized",
      status: 1403
    };
  }

  try {
    const response = await http({
      method: method,
      url: url,
      data: data,
      headers: {
        'Authorization': 'Bearer ' + token.accessToken
      }
    });

    if (!verify) {
      return response;
    }

    if (!response.success) {
      throw {
        message: response.message,
        status: 402,
      }
    }

    return response;
  } catch (error) {
    if (error.response.status === 1403) {
      const { logoutUser } = useLogout();
      logoutUser();
      return;
    }

    if (tries === 0) {
      //logoutUser();
      return;
    }

    if (error.response.status === 401 && token.response !== null && tries > 0) {
      const response = await request('/auth/refresh', { refreshToken: token.refreshToken });
      setAccessToken(response.accessToken);
      return await request(url, data, method, verify, tries - 1);
    }

    throw error;
  }
}


async function requestFull(url, data, method = 'POST', verify = false, tries = 3) {
  const { token, setAccessToken } = authToken;

  if (token.refreshToken === null) {
    throw {
      message: "Unauthorized",
      status: 1403
    };
  }

  try {
    const result = await axios({
      method: method,
      url: url,
      data: data,
      headers: {
        'Authorization': 'Bearer ' + token.accessToken
      }
    });

    const response = result.data;

    if (!verify) {
      return { response, status: result.status };
    }

    if (!response.success) {
      throw {
        message: response.message,
        status: 402,
      }
    }

    return { response, status: result.status };
  } catch (error) {
    if (error.response.status === 1403) {
      const { logoutUser } = useLogout();
      logoutUser();
      return;
    }

    if (tries === 0) {
      //logoutUser();
      return;
    }

    if (error.response.status === 401 && token.response !== null && tries > 0) {
      const response = await request('/auth/refresh', { refreshToken: token.refreshToken });
      setAccessToken(response.accessToken);
      return await requestFull(url, data, method, verify, tries - 1);
    }

    throw error;
  }
}

export { http, request, requestFull };
